import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50 border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className={`text-2xl font-brand ${isScrolled || !isHome ? "text-primary-500" : "text-white"}`}>
            每日黑料
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/about"
            className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled || !isHome ? "text-foreground-600 hover:text-primary-500" : "text-white/70 hover:text-white"
            }`}
          >
            关于我们
          </Link>
          <Link
            to="/category/meiri-dasai"
            className="px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            每日黑料大赛
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`ri-${isMobileOpen ? "close" : "menu"}-line text-xl ${isScrolled || !isHome ? "text-foreground-800" : "text-white"}`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4">
          <div className="flex flex-col gap-1 pt-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/category/meiri-dasai"
              className="mt-2 px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full text-center hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              每日黑料大赛 入口
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}